<div class="carrito">
    <div class="carrito-pasos">
        <div [ngClass]="{'active': step >= 1 }" (click)="fnCambiarPaso( 1 )">
            <h1>1. Orden de Compra</h1>
        </div>
        <div [ngClass]="{'active': step >= 2 }" (click)="fnCambiarPaso( 2 )">
            <h1>2. Dirección</h1>
        </div>
        <div [ngClass]="{'active': step >= 3 }" (click)="fnCambiarPaso( 3 )">
            <h1>3. Pago</h1>
        </div>
        <div [ngClass]="{'active': step === 4 }">
            <h1>4. Confirmación</h1>
        </div>
    </div>


    <section class="carrito-productos" *ngIf=" step === 1 ">
        <div class="hide-xl">
            <section class="carrito-pago-contenedor-detalle-total fondo-blue">
                <div>
                    <p class="color-white">
                        Subtotal: &ensp; {{ newVenta.subtotal | currency:newVenta.divisa:'symbol':'.2-2' }}
                    </p>

                    <p class="color-purple">
                        Descuento: - {{ newVenta.descuentoCupon | currency:newVenta.divisa:'symbol':'.2-2' }}
                    </p>
                    <p class="color-white">
                        Costo de envío:
                        <span *ngIf=" envio.id !== 0  " class="color-white">
							{{ envio.costo | currency:newVenta.divisa:'symbol':'.2-2' }}
						</span>
                        <span *ngIf=" envio.id === 0  " class="color-white">
							Por calcular
						</span>
                    </p>
                    <p class="color-white">
                        Gran Total: {{ newVenta.total | currency:newVenta.divisa:'symbol':'.2-2' }}
                    </p>
                </div>
            </section>
        </div>
        <section class="hide-xl">
            <div class="carrito-productos-contenedor-detalle">
                <div *ngIf="newVenta.detalle.length > 0">
                    <button class="fondo-purple continuar-compra-segura compra-segura-movil" (click)="fnContinuarCompra( 2 )">
						<p class="color-white">
							Continuar compra segura
						</p>
						<i class="fas fa-angle-double-right fa-2x" style="color: #FFF; margin-right: 15px;"></i>
					</button>
                </div>
            </div>
        </section>
        <h1 class="carrito-productos-titulo">
            Productos de tu carrito de compras
        </h1>
        <p style="font-weight: bold; color: red;" *ngIf="!allAvailables">Algunos productos de tu carrito ya no se encuentran disponibles, para avanzar con tu compra, por favor elimínalos de tu carrito.</p>
        <div class="carrito-productos-contenedor">
            <section class="carrito-productos-contenedor-header">
                <div class="carrito-productos-contenedor-header-basura">
                    <h1></h1>
                </div>
                <div class="carrito-productos-contenedor-header-nombre">
                    <h1>Producto</h1>
                </div>
                <section>
                    <div class="carrito-productos-contenedor-header-color">
                        <h1>Color</h1>
                    </div>
                    <div class="carrito-productos-contenedor-header-talla">
                        <h1>Talla</h1>
                    </div>
                    <div class="carrito-productos-contenedor-header-cantidad">
                        <h1>Cantidad</h1>
                    </div>
                </section>
                <section>
                    <div class="carrito-productos-contenedor-header-precio">
                        <h1>Precio Unitario</h1>
                    </div>
                    <div class="carrito-productos-contenedor-header-total">
                        <h1>Total</h1>
                    </div>
                </section>
            </section>
            <section class="carrito-productos-contenedor-item" *ngFor="let newProducto of newVenta.detalle" [ngClass]="{'carrito-producto-contenedor-item-no-disponible': !newProducto.disponible}">
                <div class="carrito-productos-contenedor-item-basura">
                    <h1>
                        <span (click)="fnEliminarProducto( newProducto )" title="Eliminar producto"><i class="color-blue far fa-trash-alt"></i></span>
                    </h1>
                </div>
                <div class="carrito-productos-contenedor-item-nombre">
                    <figure>
                        <img [src]="newProducto.fotografia.base64" [alt]="newProducto.nombre" loading="lazy"/>
                    </figure>
                    <span><i class="far fa-image"></i></span>
                    <label>
						{{ newProducto.nombre }}
						<p><small><b  class="color-gris-bold">SKU - {{ newProducto.currentProducto.sku }}</b></small></p>
                    </label>
                </div>
                <section>
                    <div class="carrito-productos-contenedor-item-color" *ngIf="!newProducto.disponible" style="width: 100%;text-align: center;display: block;font-weight: bold;color: #7c3551;">
                        NO DISPONIBLE
                    </div>
                    <div class="carrito-productos-contenedor-item-color" *ngIf="newProducto.disponible">
                        <div *ngIf=" !newProducto.tieneColores "> {{ newProducto.currentProducto.color.nombre }} </div>
                        <div *ngIf=" newProducto.tieneColores ">
                            <label>Color</label>
                            <div>
                                <app-select iniciar=true (newModelo)="fnSeleccionColor( $event )" [titulo]="tituloColor" [currentModelo]="newProducto.currentProducto.color" [listaElementos]="newProducto.colores"></app-select>
                            </div>
                        </div>
                    </div>
                    <div class="carrito-productos-contenedor-item-talla" *ngIf="newProducto.disponible">
                        <div *ngIf=" !newProducto.tieneTallas "> {{ newProducto.currentProducto.talla.nombre }} </div>
                        <div *ngIf=" newProducto.tieneTallas ">
                            <label>Talla</label>
                            <div>
                                <app-select iniciar=true (newModelo)="fnSeleccionTalla( $event )" [titulo]="tituloTalla" [currentModelo]="newProducto.currentProducto.talla" [listaElementos]="newProducto.listaTallas"></app-select>
                            </div>
                        </div>
                    </div>
                    <div class="carrito-productos-contenedor-item-cantidad" *ngIf="newProducto.disponible">
                        <label>Cantidad</label>
                        <div>
                            <div class="producto-cantidad">
                                <div (click)="fnCambiarCantidad( newProducto, false )" [ngClass]="{'disabled': ( newProducto.currentProducto.cantidad  === 1 ) }">
                                    <p><i class="fas fa-minus"></i></p>
                                </div>
                                <div>
                                    <input type="number" [(ngModel)]="newProducto.currentProducto.cantidad" min="1" (blur)="fnValidateCantidad( newProducto )">
                                </div>
                                <div (click)="fnCambiarCantidad( newProducto, true )" [ngClass]="{'disabled': ( newProducto.currentProducto.cantidad === newProducto.currentProducto.stock ) }">
                                    <p><i class="fas fa-plus"></i></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="carrito-productos-contenedor-item-precios">
                    <div class="carrito-productos-contenedor-item-precio">
                        <label>Precio Unitario</label>
                        <p *ngIf=" newProducto.descuento > 0 ">
                            {{ (newProducto.precio - newProducto.descuento) | currency:newVenta.divisa:'symbol':'.2-2' }}
                        </p>
                        <p *ngIf=" newProducto.descuento === 0 ">
                            {{ newProducto.precio | currency:newVenta.divisa:'symbol':'.2-2' }}
                        </p>
                    </div>
                    <div class="carrito-productos-contenedor-item-total">
                        <label>Total</label>
                        <p *ngIf=" newProducto.descuento > 0 ">
                            {{ ( (newProducto.precio - newProducto.descuento) * newProducto.currentProducto.cantidad ) | currency:newVenta.divisa:'symbol':'.2-2' }}
                        </p>
                        <p *ngIf=" newProducto.descuento === 0 ">
                            {{ ( newProducto.precio * newProducto.currentProducto.cantidad ) | currency:newVenta.divisa:'symbol':'.2-2' }}
                        </p>
                    </div>
                </section>
                <div class="carrito-productos-contenedor-item-eliminar">
                    <button class="fondo-blue" title="Eliminar producto" (click)="fnEliminarProducto( newProducto )">
						<p class="color-white">
							<i class="color-white far fa-trash-alt"></i> Eliminar producto
						</p>
					</button>
                </div>
            </section>
            <div class="carrito-productos-contenedor-detalle">
                <div class="show-xl">
                    <section class="carrito-pago-contenedor-detalle-total fondo-blue">
                        <div>
                            <p class="color-white">
                                Subtotal: &ensp; {{ newVenta.subtotal | currency:newVenta.divisa:'symbol':'.2-2' }}
                            </p>

                            <p class="color-purple">
                                Descuento: - {{ newVenta.descuentoCupon | currency:newVenta.divisa:'symbol':'.2-2' }}
                            </p>
                            <p class="color-white">
                                Costo de envío:
                                <span *ngIf=" envio.id !== 0  " class="color-white">
									{{ envio.costo | currency:newVenta.divisa:'symbol':'.2-2' }}
								</span>
                                <span *ngIf=" envio.id === 0  " class="color-white">
									Por calcular
								</span>
                            </p>
                            <p class="color-white">
                                Gran Total: {{ newVenta.total | currency:newVenta.divisa:'symbol':'.2-2' }}
                            </p>
                        </div>
                    </section>
                </div>
                <section name="step1btns">
                    <div *ngIf="newVenta.detalle.length > 0">
                        <button class="fondo-purple continuar-compra-segura" (click)="fnContinuarCompra( 2 )" [disabled]="!allAvailables" [ngClass]="{'btn-continuar-no-disponible': !allAvailables}">
							<p class="color-white">
								Continuar compra segura
							</p>
							<i class="fas fa-angle-double-right fa-2x" style="color: #FFF; margin-right: 15px;"></i>
						</button>
                    </div>
                    <div>
                        <button class="fondo-purple outline-purple" [routerLink]="['/tienda']">
							<p class="">Ver otros productos</p>
						</button>
                    </div>
                </section>
            </div>
        </div>
    </section>
    <section class="carrito-direccion" *ngIf=" step === 2 ">

        <div class="hide-xl">
            <section class="carrito-pago-contenedor-detalle-total fondo-blue">
                <div>
                    <p class="color-white">
                        Subtotal: &ensp; {{ newVenta.subtotal | currency:newVenta.divisa:'symbol':'.2-2' }}
                    </p>

                    <p class="color-purple">
                        Descuento: - {{ newVenta.descuentoCupon | currency:newVenta.divisa:'symbol':'.2-2' }}
                    </p>
                    <p class="color-white">
                        Costo de envío:
                        <span *ngIf=" envio.id !== 0  " class="color-white">
							{{ envio.costo | currency:newVenta.divisa:'symbol':'.2-2' }}
						</span>
                        <span *ngIf=" envio.id === 0  " class="color-white">
							Por calcular
						</span>
                    </p>
                    <p class="color-white">
                        Gran Total: {{ newVenta.total | currency:newVenta.divisa:'symbol':'.2-2' }}
                    </p>
                </div>
            </section>
        </div>
        <section class="hide-xl">
            <div class="carrito-productos-contenedor-detalle">
                <div *ngIf="newVenta.detalle.length > 0">
                    <button class="fondo-purple continuar-compra-segura compra-segura-movil" (click)="fnContinuarCompra( 3 )">
						<p class="color-white">
							Continuar compra segura
						</p>
						<i class="fas fa-angle-double-right fa-2x" style="color: #FFF; margin-right: 15px;"></i>
					</button>
                </div>
            </div>
        </section>

        <div class="multiple">
            <div class="col8" name="step2">
                <h1 class="carrito-direccion-titulo">
                    <div class="multiple">
                        <div class="col8">Especifica tu dirección de envío</div>
                        <div class="control col4 mb0" *ngIf=" editarDireccion && newUser.session && listaDirecciones.length > 0 ">
                            <button class="btn-continuar fondo-purple" (click)=" fnCambiarDireccion( false ) ">
								<p class="color-white">Usar dirección guardada</p>
							</button>
                        </div>
                    </div>
                </h1>
                <h5 class="carrito-direccion-subtitulo" *ngIf=" !newUser.session ">
                    Si ya tienes una cuenta puedes ingresar desde
                    <span class="color-blue-bold puntero" (click)="fnAccionModal( true )">aqui</span> o puedes crearla en esta liga
                    <a class="color-blue-bold" [routerLink]="[ '/registro' ]">(crear cuenta)</a>
                </h5>
                <section class="carrito-direccion-nueva">
                    <hr>
                    <section class="carrito-direccion-guardadas" *ngIf=" newUser.session && listaDirecciones.length > 0 && !editarDireccion ">
                        <h1 class="carrito-direccion-guardadas-titulo">Direcciones guardadas</h1>
                        <div class="carrito-direccion-guardadas-contenedor">
                            <div>
                                <app-select iniciar=false (newModelo)="fnSeleccionDireccion( $event )" [titulo]="'Seleccione una dirección de envío'" [currentModelo]="newVenta.direccion" [listaElementos]="listaDirecciones"></app-select>
                            </div>
                            <div>
                                <a class="color-purple" (click)=" fnCambiarDireccion( true ) "><br>Cambiar dirección de envío</a>
                            </div>
                        </div>
                    </section>
                    <div class="multiple" *ngIf=" editarDireccion ">
                        <div class="col4">
                            <p class="carrito-direccion-nueva-titulo">Nueva dirección</p>
                        </div>
                        <div class="col3 offset5 switch-guardar">
                            Guardar dirección
                            <label class="switch">
								<input type="checkbox" [(ngModel)]="newDireccion.guardar">
								<span class="slider round"></span>
							</label>
                        </div>
                    </div>
                    <div class="carrito-direccion-nueva-contenedor" *ngIf=" editarDireccion ">
                        <div class="multiple">
                            <div class="control col6">
                                <label>Calle</label>
                                <input type="text" placeholder="Calle" [(ngModel)]="newDireccion.calle">
                            </div>
                            <div class="control col3">
                                <label>Número exterior</label>
                                <input type="text" placeholder="Número exterior" [(ngModel)]="newDireccion.exterior">
                            </div>
                            <div class="control col3">
                                <label>Número interior</label>
                                <input type="text" placeholder="Número interior" [(ngModel)]="newDireccion.interior">
                            </div>
                        </div>
                        <div class="multiple">
                            <div class="control col3">
                                <label>Código Postal</label>
                                <input type="text" placeholder="Código Postal" [(ngModel)]="newDireccion.codigoPostal" (blur)="fnCargarColonias()">
                            </div>
                            <div class="control col9">
                                <label>Colonia</label>
                                <div>
                                    <app-select iniciar=false (newModelo)="fnSeleccionColonia( $event )" [titulo]="'Colonia'" [currentModelo]="newDireccion.colonia" [listaElementos]="listaColonias"></app-select>
                                </div>
                            </div>
                        </div>
                        <div class="multiple">
                            <div class="control col4">
                                <label>Municipio</label>
                                <input type="text" placeholder="Municipio" [(ngModel)]="newDireccion.municipio">
                            </div>
                            <div class="control col4">
                                <label>Estado</label>
                                <input type="text" placeholder="Estado" [(ngModel)]="newDireccion.estado">
                            </div>
                            <div class="control col4">
                                <label>País</label>
                                <input type="text" placeholder="País" [(ngModel)]="newDireccion.pais">
                            </div>
                        </div>
                        <div class="multiple">
                            <div class="control col12">
                                <label>Referencias</label>
                                <input type="text" placeholder="Referencias" [(ngModel)]="newDireccion.referencia">
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div class="contorl col4 show-xl">
                <br>
                <section class="carrito-pago-contenedor-detalle-total fondo-blue">
                    <div>
                        <p class="color-white">
                            Subtotal: &ensp; {{ newVenta.subtotal | currency:newVenta.divisa:'symbol':'.2-2' }}
                        </p>

                        <p class="color-purple">
                            Descuento: - {{ newVenta.descuentoCupon | currency:newVenta.divisa:'symbol':'.2-2' }}
                        </p>
                        <p class="color-white">
                            Costo de envío:
                            <span *ngIf=" envio.id !== 0  " class="color-white">
								{{ envio.costo | currency:newVenta.divisa:'symbol':'.2-2' }}
							</span>
                            <span *ngIf=" envio.id === 0  " class="color-white">
								Por calcular
							</span>
                        </p>
                        <p class="color-white">
                            Gran Total: {{ newVenta.total | currency:newVenta.divisa:'symbol':'.2-2' }}
                        </p>
                    </div>
                </section>

                <button class="fondo-purple continuar-compra-segura" name="step2" (click)="fnContinuarCompra( 3 )">
					<p class="color-white">
						Continuar compra segura
					</p>
					<i class="fas fa-angle-double-right fa-2x" style="color: #FFF; margin-right: 15px;"></i>
				</button>

            </div>
        </div>
        <section class="carrito-direccion-envio" *ngIf=" listaServicios.length > 0 ">
            <hr>
            <h1 class="carrito-direccion-envio-titulo">Seleccione el servicio de paquetería para el envío de su pedido</h1>
            <section class="contenedor-paqueterias">
                <div *ngFor="let newItem of listaServicios">
                    <figure>
                        <div><img [src]=" newItem.logotipo " [alt]="newItem.nombre" loading="lazy" /></div>
                    </figure>
                    <figcaption>
                        <div *ngFor=" let newServicio of newItem.servicios " [ngClass]="{'active': envio.id === newServicio.id}" (click)="fnCambiarTipoEnvio( newServicio )">
                            <div>
                                <span *ngIf=" envio.id === newServicio.id">
									<i class="color-purple fas fa-dot-circle"></i>
								</span>
                                <span *ngIf=" envio.id !== newServicio.id">
									<i class="color-grey fas fa-circle"></i>
								</span>
                            </div>
                            <div>{{ newServicio.nombre }}</div>
                            <div class="color-blue-bold">
                                {{ newServicio.costo | currency:newVenta.divisa:'symbol':'.2-2' }}
                            </div>
                        </div>
                    </figcaption>
                </div>
            </section>


            <section class="carrito-pago-contenedor-detalle-total fondo-blue">
                <div>
                    <p class="color-white">
                        Subtotal: &ensp; {{ newVenta.subtotal | currency:newVenta.divisa:'symbol':'.2-2' }}
                    </p>

                    <p class="color-purple">
                        Descuento: - {{ newVenta.descuentoCupon | currency:newVenta.divisa:'symbol':'.2-2' }}
                    </p>
                    <p class="color-white">
                        Costo de envío:
                        <span *ngIf=" envio.id !== 0  " class="color-white">
							{{ envio.costo | currency:newVenta.divisa:'symbol':'.2-2' }}
						</span>
                        <span *ngIf=" envio.id === 0  " class="color-white">
							Por calcular
						</span>
                    </p>
                    <p class="color-white">
                        Gran Total: {{ newVenta.total | currency:newVenta.divisa:'symbol':'.2-2' }}
                    </p>
                </div>
            </section>

            <div class="continuar-compra-paqueteria">
                <div *ngIf="newVenta.detalle.length > 0">
                    <button class="fondo-purple continuar-compra-segura compra-segura-movil" (click)="fnContinuarCompra( 3 )">
						<p class="color-white">
							Continuar compra segura
						</p>
						<i class="fas fa-angle-double-right fa-2x" style="color: #FFF; margin-right: 15px;"></i>
					</button>
                </div>
            </div>

        </section>
        <!-- <div class="control col4">
            <button class="fondo-blue btn-continuar" (click)="fnContinuarCompra( 3 )">
				<p class="color-white">Continuar con la compra</p>
			</button>
        </div> -->
    </section>
    <section class="carrito-pago" *ngIf=" step === 3 ">
        <h1 class="carrito-pago-titulo">
            Selecciona tu forma de pago
        </h1>
        <section>
            <div class="carrito-pago-contenedor">
                <div>
                    <!-- <div [ngClass]="{'active': tipoPago === 1 }" (click)="fnCambiarFormaPago( 1 )">
                        <h1>Tarjeta de Crédito / Débito</h1>
                    </div> -->
                    <div [ngClass]="{'active': tipoPago === 2 }" (click)="fnCambiarFormaPago( 2 )">
                        <h1>PayPal</h1>
                    </div>
                </div>
                <!-- <section *ngIf=" tipoPago === 1">

                    <section class="carrito-pago-contenedor-productos">
                        <h1>
                            <p class="color-black-bold" (click)=" showDetalle = !showDetalle ">
                                Mostrar productos
                                <span *ngIf=" showDetalle "><i class="fas fa-chevron-up"></i></span>
                                <span *ngIf=" !showDetalle "><i class="fas fa-chevron-down"></i></span>
                            </p>
                        </h1>
                        <div *ngIf=" showDetalle " class="animated fadeIn">
                            <section *ngFor="let newProducto of newVenta.detalle">
                                <app-item-detalle-carrito [newTipo]=2 [newProducto]="newProducto" [newDivisa]="newVenta.divisa"></app-item-detalle-carrito>
                            </section>
                        </div>
                        <section class="carrito-pago-contenedor-detalle-total fondo-blue">
                            <p class="color-white">
                                Gran Total: {{ newVenta.total | currency:newVenta.divisa:'symbol':'.2-2' }}
                            </p>
                        </section>
                    </section>
                    <div class="carrito-pago-contenedor-cupon col8 offset2" *ngIf=" !newVenta.conCupon ">
                        <h1>¿Tienes un cupón de descuento? Aplicalo aquí</h1>
                        <div>
                            <div class="control">
                                <input type="text" placeholder="Ingrese el código de tu cupón" [(ngModel)]="valorCupon">
                            </div>
                            <div class="control-btn">
                                <button class="fondo-purple" (click)="fnAplicarCupon()">Aplicar</button>
                            </div>
                        </div>
                    </div>
                    <div class="carrito-pago-contenedor-cupon col8 offset2" *ngIf=" newVenta.conCupon ">
                        <h1 class="color-blue">
                            Cupón aplicado
                            <span class="color-purple">
								{{ newVenta.descuentoCupon | currency:newVenta.divisa:'symbol':'.2-2' }}
							</span>
                        </h1>
                    </div>
                    <br>

                    <div class="multiple-always col12">
                        <div class="control col6">
                            <label>Nombre del titular</label>
                            <input (focus)="fnClearControl( $event )" name="nombre" type="text" placeholder="Nombre del titular" [(ngModel)]="newPago.billing.nombre">
                        </div>
                        <div class="control col6">
                            <label>Apellidos del titular</label>
                            <input (focus)="fnClearControl( $event )" name="nombre" type="text" placeholder="Apellido del titular" [(ngModel)]="newPago.billing.apellido">
                        </div>
                    </div>
                    <div class="control-multiple col12">
                        <div class="control col6">
                            <label>Número de tarjeta</label>
                            <input (focus)="fnClearControl( $event )" name="tarjeta" type="number" placeholder="Número de tarjeta" [(ngModel)]="newPago.card.number">
                        </div>
                        <div class="multiple-always col6 control-flex">
                            <div class="control col4">
                                <label>Mes</label>
                                <app-select iniciar=true (newModelo)="fnMesSeleccion($event)" [titulo]="inputMes" [currentModelo]="newPago.card.exp_month" [listaElementos]="listaMeses" [search]=false></app-select>
                            </div>
                            <div class="control col4">
                                <label>Año</label>
                                <app-select iniciar=true (newModelo)="fnAnioSeleccion($event)" [titulo]="inputAnio" [currentModelo]="newPago.card.exp_year" [listaElementos]="listaAnios" [search]=false></app-select>
                            </div>
                            <div class="control col4 control-cvc">
                                <label>CVC</label>
                                <input (focus)="fnClearControl( $event )" name="cvc" type="password" placeholder="CVC" [(ngModel)]="newPago.card.cvv">
                            </div>
                        </div>
                    </div>
                    <div class="control col12">
                        <label>Calle</label>
                        <input (focus)="fnClearControl( $event )" name="domicilio" type="text" placeholder="Dirección" [(ngModel)]="newPago.billing.direccion">
                    </div>
                    <div class="multiple-always col12">
                        <div class="control col3">
                            <label>Código Postal</label>
                            <input (focus)="fnClearControl( $event )" name="codigoPostal" class="codigoPostal" type="text" placeholder="Código Postal" [(ngModel)]="newPago.billing.codigoPostal" (ngModelChange)="watchCodigoPostal($event)">
                        </div>
                        <div class="control col9">
                            <label>Colonia</label>
                            <app-select iniciar=true (newModelo)="fnSeleccionColoniaTarjeta( $event )" [titulo]="inputColonia" [currentModelo]="newPago.billing.colonia" [listaElementos]="listaColonias" [search]=true></app-select>
                        </div>
                    </div>

                    <div class="col8 offset2">
                        <p> Haciendo click en "Finalizar Compra" aceptas nuestros <a class="color-blue" [routerLink]="[ '/terminos-condiciones' ]">términos y condiciones</a>.</p>
                        <button class="fondo-purple btn-finalizar-compra continuar-compra-segura" (click)="fnPago()">
							<p>Finalizar Compra </p>
							<i class="fas fa-angle-double-right " style="color: #FFF; margin-right: 15px;"></i></button>
                    </div>
                </section> -->
                <section *ngIf=" tipoPago === 2">
                    <div class="carrito-pago-contenedor-cupon col8 offset2" *ngIf=" !newVenta.conCupon ">
                        <h1>¿Tienes un cupón de descuento? Aplicalo aquí</h1>
                        <div>
                            <div class="control">
                                <input type="text" placeholder="Ingrese el código de tu cupón" [(ngModel)]="valorCupon">
                            </div>
                            <div class="control-btn">
                                <button class="fondo-purple" (click)="fnAplicarCupon()">Aplicar</button>
                            </div>
                        </div>
                    </div>
                    <div class="carrito-pago-contenedor-cupon col8 offset2" *ngIf=" newVenta.conCupon ">
                        <h1 class="color-blue">
                            Cupón aplicado
                            <span class="color-purple">
								{{ newVenta.descuentoCupon | currency:newVenta.divisa:'symbol':'.2-2' }}
							</span>
                        </h1>
                    </div>
                    <br>
                    <section class="carrito-pago-contenedor-productos">
                        <h1>
                            <p class="color-black-bold" (click)=" showDetalle = !showDetalle ">
                                Mostrar productos
                                <span *ngIf=" showDetalle "><i class="fas fa-chevron-up"></i></span>
                                <span *ngIf=" !showDetalle "><i class="fas fa-chevron-down"></i></span>
                            </p>
                        </h1>
                        <div *ngIf=" showDetalle " class="animated fadeIn">
                            <section *ngFor="let newProducto of newVenta.detalle">
                                <app-item-detalle-carrito [newTipo]=2 [newProducto]="newProducto" [newDivisa]="newVenta.divisa"></app-item-detalle-carrito>
                            </section>
                        </div>
                        <section class="carrito-pago-contenedor-detalle-total fondo-blue">
                            <div>
                                <p class="color-white">
                                    Subtotal: {{ newVenta.subtotal | currency:newVenta.divisa:'symbol':'.2-2' }}
                                </p>

                                <p class="color-white">
                                    Gran Total: {{ newVenta.total | currency:newVenta.divisa:'symbol':'.2-2' }}
                                </p>
                            </div>
                        </section>
                    </section>
                    <ngx-paypal [config]="payPalConfig"></ngx-paypal>
                </section>
            </div>
            <div class="carrito-pago-contenedor-detalle">
                <h1>Detalle de compra</h1>
                <div>
                    <section *ngFor="let newProducto of newVenta.detalle">
                        <app-item-detalle-carrito [newTipo]=2 [newProducto]="newProducto" [newDivisa]="newVenta.divisa"></app-item-detalle-carrito>
                    </section>
                </div>
                <section class="carrito-pago-contenedor-detalle-total fondo-blue">
                    <div>
                        <p class="color-white">
                            Subtotal: &ensp; {{ newVenta.subtotal | currency:newVenta.divisa:'symbol':'.2-2' }}
                        </p>

                        <p class="color-purple">
                            Descuento: - {{ newVenta.descuentoCupon | currency:newVenta.divisa:'symbol':'.2-2' }}
                        </p>
                        <p class="color-white">
                            Envío: {{ envio.costo | currency:newVenta.divisa:'symbol':'.2-2' }}
                        </p>
                        <p class="color-white">
                            Gran Total: {{ newVenta.total | currency:newVenta.divisa:'symbol':'.2-2' }}
                        </p>
                    </div>
                </section>
            </div>
        </section>
    </section>
    <section class="carrito-confirmacion" *ngIf=" step === 4 "></section>
</div>


<section class="modal-acceso" *ngIf=" showModalAcceso ">
    <div (click)="fnAccionModal( false )"></div>
    <section class="modal-acceso-content">
        <span (click)="fnAccionModal( false )"><i class="color-white fas fa-times"></i></span>
        <figure>
            <img src="assets/images/logo-big.png" loading="lazy" alt="Pawerful PetShop" />
        </figure>
        <div class="leyenda">
            <p>{{ mensajeSesion.mensaje }}</p>
        </div>
        <div class="acceso-form-content primario">
            <input [(ngModel)]="newUsuario.username" type="text" placeholder="Ingresa tu correo electrónico">
        </div>
        <div class="acceso-form-content">
            <input [(ngModel)]="password" type="password" placeholder="Ingresa tu contraseña">
        </div>
        <div class="acceso-form-content-controls">
            <button (click)="fnVerificarUsuario()" class="acceso-form-content-button fondo-purple">
				Ingresar
			</button>
            <button [routerLink]="[ '/registro' ]" class="acceso-form-content-button fondo-purple-outline">
				Crear cuenta
			</button>
        </div>
        <section>
            <p class="text-center">
                <a [routerLink]="[ '/recuperacion' ]">¿Has olvidado tu contraseña? Recupérala <b class="color-blue">aquí</b></a>
            </p>
        </section>
    </section>
</section>